import { useContext } from 'react';

import { DialogContext } from './context';

/**
 * @deprecated Old dialog system — use `useCloseDialog()` from `@cast/design-system`
 * (`libs/design-system/src/components-v2/dialogs/hooks/useCloseDialog.ts`) instead.
 * Old: `const { destroy } = useDialogInstance()`. New: `const closeDialog = useCloseDialog()`.
 * To migrate a dialog that uses this, run the `/refactor-dialog <path>` skill.
 */
export const useDialogInstance = () => useContext(DialogContext);
